<template>
    <button @click.prevent="onClick">
        <slot />

        <subscriptions-reactivate-invoke
            v-slot="{
                sid,
                is_loading: is_saving,
                has_loaded: has_saved,
                error,
                invoke
            }"
            :params="{
                subscription: subscription.uuid
            }"
            @success="onSuccess"
        >
            <div>
                <modal
                    :is-open="show_destroy_modal"
                    @close="onClose"
                    v-slot="{
                        close
                    }"
                    max-w="sm"
                >
                    <base-form @submit="invoke">
                        <header class="flex items-center justify-center px-4 pt-3 sm:px-6 md:pt-4">
                            <h1 class="mb-3 text-lg font-normal font-semibold text-center">
                                Reactivate
                            </h1>
                        </header>

                        <div class="px-4 border-b sm:px-6">
                            <validator-alert :sid="sid" />
                        </div>

                        <base-form-footer
                            :is-responsive="false"
                            :show-required="false"
                            class="rounded-b"
                        >
                            <base-button
                                :is-loading="is_saving"
                                class="w-full mb-2 btn-blue"
                            >
                                Reactivate
                            </base-button>

                            <button
                                @click.prevent="close"
                                class="w-full btn"
                            >
                                Close
                            </button>
                        </base-form-footer>
                    </base-form>
                </modal>

                <error-modal
                    v-if="error && $error.is(error, { exclude: [422] })"
                    :error="error"
                />

                <modal-success
                    :is-open="show_destroyed_modal"
                    @close="show_destroyed_modal = false"
                >
                    <template slot="heading">Callback requested!</template>

                    <p class="mb-3">
                        We'll call you as soon as possible.
                    </p>

                    <template v-slot:footer="{ close }">
                        <button
                            type="button"
                            class="w-full text-center md:w-auto btn"
                            @click.prevent="close"
                        >
                            Close
                        </button>
                    </template>
                </modal-success>
            </div>
        </subscriptions-reactivate-invoke>
    </button>
</template>

<script>
    import BaseButton from './base-button'
    import BaseFormFooter from './base-form-footer'
    import SubscriptionsReactivateInvoke from './subscriptions-reactivate-invoke.vue'
    import ErrorModal from './error-modal'
    import Modal from './modal'
    import ModalSuccess from './modal-success'

    export default {
        components: {
            BaseButton,
            BaseFormFooter,
            SubscriptionsReactivateInvoke,
            ErrorModal,
            Modal,
            ModalSuccess
        },
        props: {
            subscription: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_destroy_modal: false,
                show_destroyed_modal: false,
                form: {
                    name: '',
                    telephone: '',
                    role: this.role,
                    recaptcha: ''
                }
            }
        },
        methods: {
            onClick () {
                this.$emit('open')

                setTimeout(() => {
                    this.show_destroy_modal = true
                }, 0)
            },
            onClose () {
                this.$emit('close')

                setTimeout(() => {
                    this.show_destroy_modal = false
                }, 0)
            },
            onSuccess () {
                this.$emit('success')

                this.$track(
                    'callback-requests-destroy-button',
                    'success',
                    this.$route.name || this.$route.path
                )

                setTimeout(() => {
                    this.show_destroy_modal = false

                    this.show_destroyed_modal = true
                }, 0)
            }
        }
    }
</script>
